export default {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  WAITING_FOR_ACCEPTANCE: 'WAITING_FOR_ACCEPTANCE',
  SUPERSEDED: 'SUPERSEDED',
  COMPLETED: 'COMPLETED',
}

export const offerType = {
  ADVANTAGEOUS_PRICE: 'ADVANTAGEOUS_PRICE',
  SUPER_PRICE: 'SUPER_PRICE',
  SHOCKING_PRICE: 'SHOCKING_PRICE',
}

export const OFFER_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  WAITING_FOR_ACCEPTANCE: 'WAITING_FOR_ACCEPTANCE',
  SUPERSEDED: 'SUPERSEDED',
  COMPLETED: 'COMPLETED',
  WAITING_FOR_APPLYING: 'WAITING_FOR_APPLYING',
};

export const OFFER_PRICE_TYPES = {
  ADVANTAGEOUS_PRICE: 'ADVANTAGEOUS_PRICE',
  SUPER_PRICE: 'SUPER_PRICE',
  SHOCKING_PRICE: 'SHOCKING_PRICE',
};
